import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { book, book_page, book_count } from '../../components/apipath';
import { switchHelper, dateHelper } from "../../modules/helpers";
import { ColGroup } from "../../components/ColGroup.js";

const TOTAL_COLS = 7;

function BookRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);
    const [page, setPage] = useState(1);
    const [expandedId, setExpandedId] = useState(null);
    const [search, setSearch] = useState({
        name: '',
        status: '',
        start: '',
        end: ''
    });
    const fetchData = async (page = 1, rows = 50) => {
    try {
        setLoading(true);
        const params = {
            studentName: search.name || '',
            status: search.status || '',
            startDate: search.start || '',
            endDate: search.end || '',
            page: page - 1,
            rows
        };

        const response = await axios.get(`${book_page(page - 1, rows)}`, {
            headers: { token },
            params
        });
        setRequestList(response.data);
    } catch (error) {
        console.error('Error fetching request list:', error);
    } finally {
        setLoading(false);
    }
};

    


    const fetchPageData = async () => {
    try {
        const params = {
            studentName: search.name || '',
            status: search.status || '',
            startDate: search.start || '',
            endDate: search.end || ''
        };
        const response = await axios.get(`${book_count}`, { headers: { token }, params });
        setRowsCount(response.data?.[0]?.total || 0);
    } catch (error) {
        console.error('Error fetching page data:', error);
    }
};


    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);

    useEffect(() => {
        fetchPageData();
    }, [page]);

    const handleSearch = () => {
        setPage(1); 
        fetchPageData();
        fetchData(1);
    };

    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);


    // 開始編輯
    const startEditing = (row) => {
    setEditingRequest(row);
    setUpdatedData({
        ...row,
        memo: row.memo ?? row.adm_note ?? ''
    });
    };


    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        
        let finalValue;
        if (type === 'checkbox') {
            finalValue = switchHelper(checked);
        } else if (type === 'number') {
            finalValue = value === '' ? '' : parseInt(value, 10);
        } else {
            finalValue = value;
        }
    
        setUpdatedData(prevData => ({
            ...prevData,
            [name]: finalValue
        }));
    };

    // 轉成 YYYY-MM-DD（若已是字串就原樣返回）
    const toMysqlDate = (v) => {
    if (!v) return null;
    // 已是 'YYYY-MM-DD'
    if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
    const d = new Date(v);
    if (isNaN(d)) return null;
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    };

    // 更新申請記錄
    const saveChanges = async () => {
    try {
        // 基本防守
        const memId = parseInt(updatedData.mem_id, 10);
        if (!memId || Number.isNaN(memId)) {
        console.error('❌ 缺少或不合法的 mem_id:', updatedData.mem_id);
        alert('此筆資料缺少有效的 mem_id，無法更新。'); 
        return;
        }

        const payload = {
        receive_book_id: updatedData.receive_book_id,
        mem_id: memId, // ⬅️ 關鍵：帶上 mem_id，且為數字
        core_subject: updatedData.core_subject ?? null,
        requested_date: toMysqlDate(updatedData.requested_date) ?? null,
        status: updatedData.status || '審核中',
        memo: (updatedData.memo ?? '').trim(),
        };

        console.log("Data to Send:", payload);

        const res = await axios.put(`${book}`, payload, {
        headers: { Authorization: `Bearer ${token}`, token }
        });

        const server = (res?.data && typeof res.data === 'object') ? res.data : {};
        setRequestList(prev =>
        prev.map(r => r.receive_book_id === updatedData.receive_book_id ? { ...r, ...server, ...payload } : r)
        );

        setEditingRequest(null);
    } catch (error) {
        console.error('Error updating request:', error);
    }
    };



    const formatToMysqlDatetime = (dateInput) => {
        const date = new Date(dateInput);
        const pad = (n) => (n < 10 ? '0' + n : n);
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };
    
    // 用法

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        
        setUpdatedData(prevData => {
            const currentSubjects = prevData.core_subject ? prevData.core_subject.split(',') : [];
            let updatedSubjects;
            
            if (checked) {
                // 如果選中，新增該學科
                updatedSubjects = [...currentSubjects, value];
            } else {
                // 如果取消選中，移除該學科
                updatedSubjects = currentSubjects.filter(subject => subject !== value);
            }
    
            return {
                ...prevData,
                core_subject: updatedSubjects.join(',')  // 將陣列轉為逗號分隔的字串
            };
        });
    };
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const colWeights = [1,1,1,1,1,3,1];

    return (
        <>
            <div className="mt100 container-fluid">
            {loading ? (
                    <p>載入中...</p>
                ) : (
                <div className="mt-2">
                    <div className="row mb-3">
                        <div className="col-md-2 mb-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="學生姓名"
                                value={search.name}
                                onChange={(e) => setSearch({ ...search, name: e.target.value })}
                            />
                        </div>
                        <div className="col-md-2 mb-2">
                            <select
                                className="form-control"
                                value={search.status}
                                onChange={(e) => setSearch({ ...search, status: e.target.value })}
                            >
                                <option value="">全部狀態</option>
                                <option value="審核中">審核中</option>
                                <option value="完成">完成</option>
                                <option value="取消">取消</option>
                            </select>
                        </div>
                        <div className="col-md-2 mb-2">
                            <input
                                type="date"
                                className="form-control"
                                value={search.start}
                                onChange={(e) => setSearch({ ...search, start: e.target.value })}
                            />
                        </div>
                        <div className="col-md-2 mb-2">
                            <input
                                type="date"
                                className="form-control"
                                value={search.end}
                                onChange={(e) => setSearch({ ...search, end: e.target.value })}
                            />
                        </div>
                        <div className="col-md-2 mb-2">
                            <button className="btn btn-primary w-100" onClick={handleSearch}>
                            搜尋
                            </button>
                        </div>
                    </div>
                    <table className="table table-striped border table-fixed w-100">
                        <ColGroup weights={colWeights} />
                        <thead>
                            <tr>
                                <th>學生姓名</th>
                                <th>領書科目</th>
                                <th>領書日期</th>
                                <th>狀態</th>
                                <th>申請日期</th>
                                <th>備註</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                        {requestList.map((request) => (
                                <>
                                    <tr
                                        key={request.receive_book_id}
                                        className="row-toggle"
                                        onClick={() =>
                                            setExpandedId(
                                                expandedId === request.receive_book_id
                                                    ? null
                                                    : request.receive_book_id
                                            )
                                        }
                                    >
                                    {editingRequest && editingRequest.receive_book_id === request.receive_book_id ? (
                                    <>
                                        <td colSpan={TOTAL_COLS - 1}>
                                        <div className="container">
                                            <div className="row g-2">

                                            <div className="col-md-4">
                                                <div className="input-group input-group-sm">
                                                <span className="input-group-text">學生姓名</span>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="student_name"
                                                    value={updatedData.student_name || ''}
                                                    onChange={handleInputChange}
                                                    readOnly
                                                />
                                                </div>
                                            </div>

                                            <div className="col-md-8">
                                                <div className="d-flex flex-wrap align-items-center">
                                                <label className="form-label me-3 mb-0">領書科目</label>
                                                {[
                                                    'FAR',
                                                    'REG',
                                                    'AUD',
                                                    'BAR',
                                                    'ISC',
                                                    'TCP',
                                                    'CMA Part 1',
                                                    'CMA Part 2',
                                                    'EA Part 1',
                                                    'EA Part 2',
                                                    'EA Part 3',
                                                    'CIA Part 1',
                                                    'CIA Part 2',
                                                    'CIA Part 3',
                                                    'CIA Challenge'
                                                    ].map(code => (
                                                    <div className="form-check me-3" key={code}>
                                                        <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`subject_${code.replace(/\s+/g, '_')}`}
                                                        value={code}
                                                        checked={updatedData.core_subject?.split(',').includes(code) || false}
                                                        onChange={handleCheckboxChange}
                                                        />
                                                        <label
                                                        className="form-check-label"
                                                        htmlFor={`subject_${code.replace(/\s+/g, '_')}`}
                                                        >
                                                        {code}
                                                        </label>
                                                    </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="input-group input-group-sm">
                                                <span className="input-group-text">領書日期</span>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="requested_date"
                                                    value={formatDate(updatedData.requested_date) || ''}
                                                    onChange={handleInputChange}
                                                />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="input-group input-group-sm">
                                                <span className="input-group-text">申請狀態</span>
                                                <select
                                                    className="form-select"
                                                    name="status"
                                                    value={updatedData.status || '審核中'}
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="審核中">審核中</option>
                                                    <option value="完成">完成</option>
                                                    <option value="取消">取消</option>
                                                </select>
                                                </div>
                                            </div>

                                            <div className="col-md-8">
                                                <div className="input-group input-group-sm">
                                                <span className="input-group-text">備註</span>
                                                <textarea
                                                    className="form-control"
                                                    rows={3}
                                                    name="memo"
                                                    value={updatedData.memo ?? ''}
                                                    onChange={handleInputChange}
                                                    placeholder="內部備註（不顯示給學生）"
                                                />
                                                </div>
                                            </div>

                                            </div>
                                        </div>
                                        </td>

                                        <td className="text-nowrap">
                                        <button className="btn btn-primary m-1" onClick={saveChanges}>保存</button>
                                        <button className="btn btn-secondary m-1" onClick={() => setEditingRequest(null)}>取消</button>
                                        </td>
                                    </>
                                    ) : (
                                    // 下面是非編輯狀態（不用改動，只有備註欄會顯示 memo）
                                    <>
                                        <td>
                                        <a href={`/adm/admmemberedit/${request.mem_id}`} target="_blank" rel="noopener noreferrer">
                                            {request.student_name}
                                        </a>
                                        </td>
                                        <td>{request.core_subject || "無學科"}</td>
                                        <td>{dateHelper(request.requested_date, "date")}</td>
                                        <td>{request.status || ""}</td>
                                        <td>{formatDate(request.timestamp)}</td>
                                        <td className="td-wrap" title={request.memo || ""}>{request.memo || ""}</td>
                                        <td>
                                            <button
                                                className="btn btn-primary m-1"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    startEditing(request);
                                                }}
                                            >
                                                編輯
                                            </button>
                                        </td>
                                    </>
                                    )}


                                </tr>
                                {expandedId === request.receive_book_id && (
                                    <tr>
                                        <td colSpan={TOTAL_COLS}>
                                            <div className="row p-3 bg-light border-top">

                                                <div className="col-md-6">
                                                    <strong>寄件地址：</strong><br />
                                                    {request.address || "-"}
                                                </div>

                                                <div className="col-md-6">
                                                    <strong>海外手機號碼：</strong><br />
                                                    {request.overseas_phone || "-"}
                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                )}
                                </>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-center align-items-center my-3">
                        <button className="btn btn-outline-secondary me-2" disabled={page <= 1}
                            onClick={() => {
                                setPage(prev => prev - 1);
                                fetchData(page - 1);
                            }}>
                            上一頁
                        </button>
                        <span>第 {page} 頁 / 共 {Math.ceil(rowsCount / 50)} 頁</span>
                        <button className="btn btn-outline-secondary ms-2"
                            disabled={page >= Math.ceil(rowsCount / 50)}
                            onClick={() => {
                                setPage(prev => prev + 1);
                                fetchData(page + 1);
                            }}>
                            下一頁
                        </button>
                    </div>
                </div>
                )}
            </div>
        </>
    );
}

export default BookRequest;
